// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum RefundType {
  DomesticTransfer = "DOMESTIC_TRANSFER",
  SepaTransfer = "SEPA_TRANSFER",
  ForeignTransfer = "FOREIGN_TRANSFER",
  PayGate = "PAY_GATE",
  Distributor = "DISTRIBUTOR",
  PayGateToTransfer = "PAY_GATE_TO_TRANSFER",
}
export default RefundType;
